<template>
<div id="chooseContra">
  <div class="sectionIntro">
    <div class="sectionBack">
    </div>
    <div class="introContent">

      <div class="versionContent">
        <h2 class="pageTitle">{{$t('avatamsaka.intro.title')}}</h2>
        <div class="sectionVersion">
          <div class="versionGroup">
            <div class="version" @click="getVersionPath(4)">

              <div class="imgContent">
            <img src="@/../static/image/content/indexVersion04.jpg" />
          </div>
            <div class="content">
              <h2>
                {{$t('avatamsaka.versions.version', {
                  'noticeType': $t(`avatamsaka.versions.bookName[3].text`)
                })}}
              </h2>
              <div>
                {{$t('avatamsaka.chooseIntro.v04')}}
                <div class="ref">
                  {{$t('avatamsaka.reference.title')}}：
                  {{$t('avatamsaka.chooseIntro.v04Ref')}}
                </div>
              </div>
            </div>
          </div>
          <div class="version" @click="getVersionPath(5)">

              <div class="imgContent">
            <img src="@/../static/image/content/indexVersion05.jpg" />
          </div>
            <div class="content">
              <h2>
                {{$t('avatamsaka.versions.version', {
                  'noticeType': $t(`avatamsaka.versions.bookName[4].text`)
                })}}
              </h2>
              <div>
                {{$t('avatamsaka.chooseIntro.v05')}}
                <div class="ref">
                  {{$t('avatamsaka.reference.title')}}：
                  {{$t('avatamsaka.chooseIntro.v05Ref')}}
                </div>
              </div>
            </div>
          </div>
            <div class="version" @click="getVersionPath(3)">
              <div class="imgContent">
            <img src="@/../static/image/content/indexVersion03.jpg" />
          </div>
            <div class="content">
              <h2>
                {{$t('avatamsaka.versions.version', {
                  'noticeType': $t(`avatamsaka.versions.bookName[2].text`)
                })}}
              </h2>
              <div>
                {{$t('avatamsaka.chooseIntro.v03')}}
                  <div class="ref">
                    {{$t('avatamsaka.reference.title')}}：
                    {{$t('avatamsaka.chooseIntro.v03Ref')}}
                  </div>
              </div>
            </div>
          </div>
          <div class="version" @click="getVersionPath(2)">

          <div class="imgContent">
            <img src="@/../static/image/content/indexVersion02.jpg" />
          </div>
            <div class="content">
              <h2>
                {{$t('avatamsaka.versions.version', {
                  'noticeType': $t(`avatamsaka.versions.bookName[1].text`)
                })}}
              </h2>
              <div>
                {{$t('avatamsaka.chooseIntro.v02')}}
                  <div class="ref">
                    {{$t('avatamsaka.reference.title')}}：
                    {{$t('avatamsaka.chooseIntro.v02Ref')}}
                  </div>
              </div>
            </div>
          </div>
          <div class="version" @click="getVersionPath(1)">
            <div class="imgContent">
              <img src="@/../static/image/content/indexVersion01.jpg" />
            </div>
            <div class="content">
              <h2>
                {{$t('avatamsaka.versions.version', {
                  'noticeType': $t(`avatamsaka.versions.bookName[0].text`)
                })}}
              </h2>
              <div>
                {{$t('avatamsaka.chooseIntro.v01')}}
                  <div class="ref">
                    {{$t('avatamsaka.reference.title')}}：
                    {{$t('avatamsaka.chooseIntro.v01Ref')}}
                  </div>
              </div>
            </div>
          </div>
        </div>
        <div class="postscript">
          {{$t('avatamsaka.chooseIntro.postscript')}}
        </div>
      </div>

      </div>

    </div>

  </div>

</div>
</template>

<script>

export default {
  name: 'chooseContra',
  data() {
    return {
    };
  },
  methods: {
    getVersionPath(versionId) {
      this.$router.push({
        path: `/avatamsaka/intro/${versionId}`,
      });
    },
  },
};
</script>

<style lang="scss" scoped>

#chooseContra {

  .postscript {
    text-align: center;
    padding: 20px;
  }

  .sectionIntro {
      // display: flex;
      padding-bottom: 50px;
      position: relative;

    .sectionBack {
      margin-bottom: 40px;
      width: 100%;
      height: 60%;
      top: 0;
      background: rgba(217, 226, 196, 0.4);
      position: absolute;
    }

    .sectionBack::after {

        border-top: 20vh solid rgba(217, 226, 196, 0.4);
        border-right: 50vw solid transparent;
        border-left: 50vw solid transparent;
        content: "";
        top: 100%;
        left: 0;
        position: absolute;

    }

    .introCover {
      position: absolute;
      top: 0;
      right: 0;
      padding: 0px;
      margin: 0px;
      img {
        max-width: 500px;
        width: 100%;
        float: right;
      }
    }
    .introContent {


      > h2 {
        padding-top: 2em;
        margin-left: 20px;
      }

      p {
        padding: 20px;
        padding-left: 0px;
      }
      position: sticky;
      text-align: left;
      align-self: center;
    }

    .versionContent {
      .pageTitle {
        padding: 10px 30px;
        padding-top: 2em;
        font-size: 2em;
      }
      .pageOriBook {
        font-size: 1.2em;
        padding-left: 30px;
        padding-right: 30px;
        color: rgba(29, 52, 31, 1);
      }
      .pageOriBookPS {
        font-size: 0.4;
        padding-top: 0px;
        padding-left: 30px;
        padding-right: 30px;
        display: block;
        color: rgba(29, 52, 31, 0.8);
        line-height: 0.4em;
      }
    }


  }

  .sectionVersion {

    flex-direction: row;
    margin-top: 1em;

    .versionGroup {
      display: flex;
      flex-direction: column;
      >.version:hover {
        box-shadow:
          0px 0px 10px rgba(27, 75, 51, 0.3), 0px 0px 10px rgba(27, 75, 51, 0.4),
          0px 0px 10px rgba(55, 73, 57, 0.5), 0px 0px 10px rgba(23, 78, 64, 0.7);
        cursor: pointer;
      }

    .version {
      color: #0f3f3f;
      background: rgba(255, 255, 255, 0.7);
      border: 3px solid rgba(15, 63, 63, 0.2);
      margin: 30px;
      padding: 20px;
      height: auto;
      flex: 1;
      position: relative;
      display: flex;
      .content {
        flex: 5;
        flex-direction: column;
        text-align: left;
        padding-top: 15px;
        padding-bottom: 15px;
        font-size: 1.3em;
        font-weight: 400;
        float: left;
        h2{
          padding: 0;
          font-weight: bold;
          margin-bottom: 0px;
          font-size: 1em;
          margin-left: -0.5em;
        }
        h2:hover {
          cursor: pointer;
        }
        > div {
          padding: 0px;
          padding-top: 2em;
          margin: 0px;
          font-size: 0.7em;
          .ref {
            display: block;
            font-size: 0.8em;
            color:#41551c;
            white-space: pre-line;
          }
        }
      }
      .imgContent {
        flex: 1;
        padding-right: 2em;
        img {
          width: 100%;
        }
      }
    }
}

  }

  @media (max-width: 1024px) {

      .versionContent {
        .pageTitle {
          text-shadow: 1px 1px 10px #ffffff, 1px 1px 10px #ffffff
            , 1px 1px 10px #ffffff, 1px 1px 10px #ffffff;
          font-weight: 500;
          // background: #ffffff60;
          margin-top: 0px;
          background: rgba(255, 255, 255, 0.4);
          background-clip: padding-box;
          border-top: 1.7em solid transparent;
          margin-bottom: 0px;
        }
      }

      h2 {
        text-align: center;
      }

      button {
        display: block;
        margin: 20px auto;
      }

      .sectionIntro {

        .introCover {
          position: absolute;
          right: 0;
          padding: 0px;
          margin: 0px;
          img {
            max-width: 500px;
            width: 100%;
            float: right;
          }
        }
        .introContent {

          > h2 {
            margin-left: 0px;
            color: red;
            display: none;
          }

          p {
            font-size: 0.8em;
            margin: 0px;
            padding: 0px 20px;
            overflow: scroll;
            position: relative;
            line-height: 1.2em;
            max-height: 15.6em;
            margin-right: -0.9em;
            padding-right: 0.9em;
          }

          position: sticky;
          flex: 2;
          padding: 0px;
          z-index: 1;
          margin: 20px;
          margin-top: 0px;
          text-align: left;
          align-self: center;

          .versionGroup {
            background: rgba(255, 255, 255, 0.4);
          }
        }
      }


      .sectionVersion {

        margin-top: 0px;

        .versionGroup {
          height: 100%;
          width: 100%;

          display: grid;
          width: 100%;
        .version {
          margin: 30px;
          margin-top: 0px;
          padding: 20px;
          height: auto;
          position: relative;

          .content {

            padding: 0px;
            width: calc(100% - 128px);
            overflow: hidden;
            float: left;
            h2{
              padding-bottom: 0px;
              font-weight: bold;
              font-size: 0.9em;
              margin-bottom: 0px;
            }
            h2:hover {
              cursor: pointer;
            }
            p {

              font-size: 0.8em;
              margin: 0px;
              padding: 0px;

              overflow: hidden;
              position: relative;
              line-height: 1.2em;
              max-height: 12em;
              margin-right: -0.9em;
              padding-right: 0.9em;
            }
            p:before {

              content: '...';

              position: absolute;
              right: 0;
              bottom: 0;
            }
          }
          .imgContent {
            padding-right: 0px;
            width: 128px;
            height: 200px;
            float: left;
            img {
              width: auto;
              height: calc(100% - 20px);
            }
          }
        }
    }

    :first-child {
      .version:first-child {
        margin-top: 30px;
      }
    }

      }


  }

  @media (max-width: 768px) {
    .sectionIntro {
      .introContent {
        .versionContent {
          .pageTitle {
            padding: 1em 0px;
            border: none;
            background: none;
          }
          .sectionVersion {
            .versionGroup {
              .version {
                margin: 0px;
                padding: 1em;
                display: flex;
                flex-direction: column;
                margin-bottom: 2em;
                .imgContent {
                  width: 100%;
                  max-height: 8em;
                  overflow: hidden;
                  margin-bottom: 2em;
                  img {
                    margin-top: -10%;
                    width: 100%;
                    height: auto;

                  }
                }
                .content {
                  width: auto;
                }
              }
            }
          }
        }
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/ChooseIntro.vue